export default __webpack_public_path__ + "static/media/z-arista.light.36325775.ttf";